// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__pVcp-","head":"Table_head__15XAC","col":"Table_col__2Zbhu"};